import type { SituationsResponse } from "@/hooks/useSituations";

type ReaderBoot = {
  startedAt: number;
  tokenClaimed: boolean;
  readingClaimed: boolean;
  token: Promise<string | null>;
  reading: Promise<{ token: string; data: SituationsResponse } | null>;
};

function currentBoot(): ReaderBoot | undefined {
  if (typeof window === "undefined") return;
  return (window as typeof window & { __fahaliReaderBoot?: ReaderBoot }).__fahaliReaderBoot;
}

/** Consume once: token refreshes must always mint a new server credential. */
export async function takeReaderBootToken(): Promise<{ token: string | null } | null> {
  const boot = currentBoot();
  if (!boot || boot.tokenClaimed || Date.now() - boot.startedAt > 30_000) return null;
  boot.tokenClaimed = true;
  return { token: await boot.token.catch(() => null) };
}

/** Only the same guest session may reuse this reading; never another account. */
export async function takeReaderBootReading(token: string | null): Promise<SituationsResponse | null> {
  const boot = currentBoot();
  if (!token || !boot || boot.readingClaimed || Date.now() - boot.startedAt > 30_000) return null;
  boot.readingClaimed = true;
  const result = await boot.reading.catch(() => null);
  const age = result?.data?.asOf ? Date.now() - Date.parse(result.data.asOf) : NaN;
  if (result?.token !== token || !Number.isFinite(age) || age < -5_000 || age > 60_000 || !Array.isArray(result.data.secondary)) return null;
  return result.data;
}
